export default "__VITE_ASSET__c109aa1f__"